
import React, { Component } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip, Col, Row } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BlockUi from 'react-block-ui';
import ChatsService from 'src/controllers/ChatController';
import Timeline from '../misc/timeline';
class Contact extends Component {

    constructor(props) {

        super(props)

        this.state = {
            loading: false,
            view: "contact",
            interaction: null
        }

        this.handleMessage = this.handleMessage.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.contactClick = this.contactClick.bind(this);
        this.timelineClick = this.timelineClick.bind(this);
    }
    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.view !== "contact" && ((this.props.action === "editcontact" && prevProps.contactId !== this.props.contactId) || this.props.action === "addcontact"))
            this.contactClick();
    }

    handleMessage(event) {

        if (this.props.show && event.data.Method === "SetFormChange") {
            if (event.data.Status === "ABCLOSE") {
                this.setState({ loading: true });
                setTimeout(this.closeModal, 500);
            }

            if (event.data.Status === "ABCANCEL")
                this.props.toggleModal();

        }
    }

    closeModal = e => {
        this.setState({ loading: false });
        this.props.toggleModal();
        if (this.props.reload != null)
            this.props.reload();
    }
    contactClick(e) {
        this.setState({ view: "contact" });
    }

    timelineClick(e) {
        ChatsService.findContact({
            bookId: this.props.contactId,
            tenantId: this.props.tenantId
        }, data => {
            if (data) {
                let interaction = {
                    bookId: data[0].contactId,
                    contacts: data,
                    from: data[0].phone || data[0].mail,
                    email: data[0].mail,
                    phone: data[0].phone,
                    name: data[0].name
                }

                this.setState({
                    interaction: interaction
                });

                this.setState({ view: "timeline" });
            }
        });

    }
    render() {
        let url = this.props.searchForms.toLowerCase().split("search")[0];
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} dialogClassName="modal-90w">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("address-book")} /> {this.props.t(this.props.action)}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.props.action === "editcontact" &&
                            <Row>
                                <Col className={
                                    "fs-4 pb-3 " +
                                    (this.state.view === "contact" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                } onClick={this.contactClick}>
                                    <FontAwesomeIcon icon={duotone('address-book')} /> <span className='chattab'>{this.props.t("contact")}</span>
                                </Col>

                                <Col className={
                                    "fs-4 pb-3 " +
                                    (this.state.view === "timeline" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                } onClick={this.timelineClick}>
                                    <FontAwesomeIcon icon={duotone('rectangle-history-circle-user')} /> <span className='chattab'>{this.props.t("timeline")}</span>
                                </Col>
                            </Row>
                        }

                        <Row style={{ display: (this.state.view === "contact") ? "block" : "none" }}>
                            <Col>
                                <iframe title="contactForm" src={`${url}?state=${this.props.action === "addcontact" ? "new" : "modify"}&campaignId=${this.props.addressBookId}&pin=${this.props.userId}${this.props.action === "addcontact" ? "" : `&contactId=${this.props.contactId}`}&phone=${this.props.phone ? this.props.phone : ""}`} width={"100%"} height={"735px"}></iframe>
                            </Col>
                        </Row>
                        {this.state.view === "timeline" && (
                            <Row>
                                {this.state.interaction && <Timeline interaction={this.state.interaction} />}
                            </Row>
                        )}
                    </Modal.Body>
                </BlockUi>
            </Modal>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        addressBookId: state.agent.addressBookId,
        searchForms: state.parameters.searchForms,
        tenantId: state.agent.tenantId,
        aiEnabled: state.parameters.aiEnabled
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(Contact);

